/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import "./registerServiceWorker";
import "viewerjs/dist/viewer.css";
import "boxicons/css/boxicons.min.css";
import VueViewer from "v-viewer";
import VueMarqueeSlider from "vue-marquee-slider";

import VueApexCharts from "vue-apexcharts";

Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(VueApexCharts);
Vue.use(VueViewer, {
  defaultOptions: {
    zIndex: 9999,
  },
});
Vue.use(VueMarqueeSlider);
Vue.component("apexchart", VueApexCharts);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
